import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() disabled = false;
  @Input() type = '';
  @Input() label!: string;
  @Input() variant:
    | 'primary'
    | 'light'
    | 'info'
    | 'outline'
    | 'danger'
    | 'danger-outline'
    | 'primary-outline' = 'primary';
  @Input() class = '';
  @Input() icon = '';
  @Input() loading = false;
  @Input() iconPosition = 'right';
  @Output() onClick = new EventEmitter();
}
